export default {
  title: 'Restore password',
  instructions: 'A message will be sent to the email to reset the password.',
  recoverPasswordButton: 'Continue',
  returnLogindButton: 'Back',
  tryAgainButton: 'Try again',
  success: {
    label: 'The message has been sent successfully.'
  },
  email: {
    inputLabel: 'Email'
  }
}
